<template>
  <v-container>
    <v-layout>
      <v-flex sm4 class="mt-2">
        <h2>User Management</h2>
      </v-flex>
      <v-flex sm4 offset-sm4 class="text-xs-right">
        <AddUserDialog @result="showMessage" :userTypes="userTypes" />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm4 offset-sm8>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <br />
    <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-1"
      :search="search"
      :loading="loading"
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td class="text-xs-center">
          {{
            props.item.role && props.item.role.name ? props.item.role.name : ""
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.active ? "Active" : "Inactive" }}
        </td>
        <td class="text-xs-center" style="min-width: 120px">
          <div class="actions">
            <ViewUserDialog :userDetails="props.item" />
            <EditUserDialog
              :userDetails="props.item"
              :userTypes="userTypes"
              @result="showMessage"
            />
          </div>
        </td>
      </template>
      <template v-slot:pageText="props">
        Users {{ props.pageStart }} - {{ props.pageStop }} of
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ message }}
    </v-snackbar>
  </v-container>
</template>
<script>
  import api from "../api/datadash";
  import { mapState } from "vuex";
  import ViewUserDialog from "../components/user/ViewUserDialog.vue";
  import AddUserDialog from "../components/user/AddUserDialog.vue";
  import EditUserDialog from "../components/user/EditUserDialog.vue";
  export default {
    components: { ViewUserDialog, AddUserDialog, EditUserDialog },
    data() {
      return {
        loading: false,
        search: "",
        headers: [
          {
            text: "#",
            value: "id",
            align: "right",
          },
          { text: "Name", value: "name", align: "center" },
          { text: "Email", value: "email", align: "center" },
          { text: "User Type", value: "role", align: "center" },
          { text: "Status", value: "active", align: "center" },
          { text: "Action", sortable: false, align: "center" },
        ],
        users: [],
        userTypes: [],
        color: "",
        message: "",
        snackbar: false,
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.fetchUserTypes();
      this.fetchUsers();
    },
    methods: {
      async fetchUserTypes() {
        try {
          const { data } = await api.fetchData(this.auth.token, "user-roles");
          this.userTypes = data;
        } catch (e) {
          // console.log(e);
        }
      },
      async fetchUsers() {
        this.loading = true;
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            "official-user"
          );
          this.users = data.data.users;
        } catch (e) {
          // console.log(e);
        }
        this.loading = false;
      },
      showMessage(event) {
        this.color = event[1];
        this.message = event[0];
        this.snackbar = true;
        if (this.color == "success") {
          this.fetchUsers();
        }
      },
    },
  };
</script>
<style scoped>
  .actions {
    display: none;
  }
  tr:hover td > .actions {
    display: block;
  }
</style>
